import { useRouter } from 'next/router';

import {
  getInternalLocaleFromRFC4646Locale,
  InternalLocale,
  RFC4646Locale,
} from '@catawiki/locale';

export const useLocale = () => {
  const isoLocale =
    (useRouter().locale as RFC4646Locale) || RFC4646Locale.ENGLISH;
  const internalLocale =
    getInternalLocaleFromRFC4646Locale(isoLocale) || InternalLocale.ENGLISH;

  return {
    isoLocale,
    internalLocale,
  };
};
